import React from 'react';
import styled from 'styled-components';
import { round } from 'lodash';
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import classNames from 'classnames';

const StyledPercentComponentContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;

  .green {
    color: #1a9e88;
  }
  .red {
    color: #f2766b;
  }

  .percent-container {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
  }

  .percent {
    display: flex;
    align-items: center;
  }

  .left-indent {
    margin-left: 5px;
  }
`;

export const getPercentDifference = (prevVal, val) => {
  return prevVal !== 0 ? round((Math.abs(prevVal - val) / prevVal) * 100, 2) || 0 : 'n/a';
};

const PercentComponent = ({ prevValue, value, diff }) => {
  if (value === 0) {
    return (
      <StyledPercentComponentContainer>
        <div>{diff}</div>
        <div className={classNames('percent-container', 'left-indent')}>(n/a%)</div>
      </StyledPercentComponentContainer>
    );
  }

  const isNotNullDiff = prevValue - value !== 0;
  const percentDifference = getPercentDifference(value, prevValue);
  const isPrevValueBigger = prevValue > value;

  return (
    <StyledPercentComponentContainer>
      <div>{diff}</div>
      {isNotNullDiff ? (
        <div className={classNames('percent-container', 'left-indent')}>
          (
          <div
            className={classNames('percent', { green: isPrevValueBigger, red: !isPrevValueBigger })}
          >
            {isPrevValueBigger ? <CaretUpOutlined /> : <CaretDownOutlined />}
            <span>{`${percentDifference}%`}</span>
          </div>
          )
        </div>
      ) : (
        <div className="left-indent">(0%)</div>
      )}
    </StyledPercentComponentContainer>
  );
};

export default PercentComponent;
